import { render } from "./Campaigns.vue?vue&type=template&id=7a39866f&scoped=true"
import script from "./Campaigns.vue?vue&type=script&lang=js"
export * from "./Campaigns.vue?vue&type=script&lang=js"

import "./Campaigns.vue?vue&type=style&index=0&id=7a39866f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a39866f"]])

export default __exports__